// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zsfl","option":"styles_option__2Hm_h","selected":"styles_selected__2Z4p2"};